import { apiClient } from "@/config/api";
import {
  PhimApiListResponse,
  PhimApiDetailResponse,
  GetPhimApiListParams,
  BulkPhimApiResult,
  SearchPhimApiParams,
} from "@/services/phimApiService";
import { ApiResponse } from "@/types/status";

const OPHIM_ENDPOINTS = {
  LIST: (type: string) => `/ophim-sync/ophimapi/list/${type}`,
  SEARCH: "/ophim-sync/ophimapi/search",
  MOVIE: (slug: string) => `/ophim-sync/ophimapi/movie/${slug}`,
  BULK_CREATE: "/articles/bulk-ophim",
} as const;

export const ophimApiService = {
  // Lấy danh sách phim từ OPhim (qua backend proxy)
  getMovieList: async (
    type: string,
    params: GetPhimApiListParams = {}
  ): Promise<ApiResponse<PhimApiListResponse>> => {
    return await apiClient.get(OPHIM_ENDPOINTS.LIST(type), params as any);
  },

  // Tìm kiếm phim từ OPhim (qua backend proxy)
  searchMovies: async (
    params: Omit<SearchPhimApiParams, 'sort_lang'>
  ): Promise<ApiResponse<PhimApiListResponse>> => {
    return await apiClient.get(OPHIM_ENDPOINTS.SEARCH, params as any);
  },

  // Lấy chi tiết phim từ OPhim (qua backend proxy)
  getMovieDetail: async (
    slug: string
  ): Promise<ApiResponse<PhimApiDetailResponse>> => {
    return await apiClient.get(OPHIM_ENDPOINTS.MOVIE(slug));
  },

  // Import và tạo articles từ danh sách slugs OPhim
  createBulkFromOPhim: async (
    slugs: string[]
  ): Promise<ApiResponse<BulkPhimApiResult>> => {
    return await apiClient.post(OPHIM_ENDPOINTS.BULK_CREATE, { slugs });
  },
};
